import { useEffect } from "react";
import { useClientView } from "./ClientViewProvider";
import { useClientViewRouteLocale } from "./ClientViewRouteLocaleContext";
import { IntlProvider, useCurrency, useLocale } from "../../intl";
import { buildIntlAnalyticsContext, setIntlAnalyticsContext } from "../../intl/analyticsContext.js";

function IntlAnalyticsBridge({ children }) {
  const { slug, manifest } = useClientView();
  const { urlLocale } = useClientViewRouteLocale();
  const { locale } = useLocale();
  const { displayCurrency, ratesMeta, rates } = useCurrency();

  useEffect(() => {
    setIntlAnalyticsContext(
      buildIntlAnalyticsContext({
        locale,
        displayCurrency,
        manifest,
        urlLocale,
        clientViewSlug: slug,
        surface: "clientView",
        ratesMeta,
        rates,
      })
    );
  }, [locale, displayCurrency, manifest, urlLocale, slug, ratesMeta, rates]);

  return children;
}

export default function ClientViewIntlBridge({ children }) {
  const { manifest } = useClientView();
  const { urlLocale } = useClientViewRouteLocale();

  return (
    <IntlProvider surface="clientView" manifest={manifest} urlLocale={urlLocale}>
      <IntlAnalyticsBridge>{children}</IntlAnalyticsBridge>
    </IntlProvider>
  );
}
